/* eslint-disable */
import axios from "axios";


// Dev points at the prod API (api.craftcollect.africa). VUE_APP_BASE_URL_FLOCKER is
// the prod base; VUE_APP_BASE_URL_UAT is for the paysol.africa UAT box.
// Switch by setting VUE_APP_API_ENV=uat in .env.local.
export const base = (process.env.VUE_APP_API_ENV === 'uat'
    ? process.env.VUE_APP_BASE_URL_UAT
    : process.env.VUE_APP_BASE_URL_FLOCKER)

export const authUrl =  base;
export const flocker =  base+"/index.php";
export const uploads =  base+"/uploads/";

// Public portal host — used to build branded social-share links so we don't
// leak the API host (api.craftcollect.africa / api.paysol.africa) in URLs
// that get pasted on Facebook, WhatsApp, X, etc. The portal proxies /s/*
// to the API's share.php via an .htaccess RewriteRule.
export const portal = process.env.VUE_APP_PORTAL_URL || (
    (base || '').indexOf('paysol') > -1 ? 'https://uat.flockr.africa' : 'https://flockr.africa'
);

// Hard cap: every API call must either resolve or fail within REQUEST_TIMEOUT_MS. Without this
// axios waits forever, which combined with PHP's set_time_limit(0) means a single stuck DB query
// freezes the UI with no error and no recovery. 15s is generous for normal calls; M-Pesa STK
// initiation occasionally takes longer and has its own polling pattern after the initial response.
const REQUEST_TIMEOUT_MS = 15000;

export const execute = (params, url) => {
    const tokenStr = localStorage.getItem("authToken"); // Get token dynamically
    return axios.post(url, params, {
        headers: { "Authorization": `Bearer ${tokenStr}` },
        timeout: REQUEST_TIMEOUT_MS
    })
}

export const executeJson = (params, url) => {
    const tokenStr = localStorage.getItem("authToken"); // Get token dynamically
    return axios.post(url, params, {
        headers: {
            "Authorization": `Bearer ${tokenStr}`,
            "Content-Type": "application/json" // Specify JSON content type
        },
        timeout: REQUEST_TIMEOUT_MS
    });
}




export const executeDownload = (params, url) => {
    const tokenStr = localStorage.getItem("authToken");
    return axios.post(url, params, {
        headers: { "Authorization": `Bearer ${tokenStr}` },
        responseType: 'blob',
        timeout: REQUEST_TIMEOUT_MS
    })
}
export const execute2 = (params, url) => {
    return axios.post(url, params, { timeout: REQUEST_TIMEOUT_MS })
}
/**
 * Format a price with its ISO-4217 currency code prefix.
 * Falls back to 'KES' if no currency supplied — keeps every legacy callsite working
 * while we migrate them to pass an explicit currency.
 *
 *   formatCurrency(285) → "KES 285"
 *   formatCurrency(81225, 'TZS') → "TZS 81,225"
 *   formatCurrency(null, 'UGX') → "UGX 0"
 */
export const formatCurrency = (amount, currency) => {
    const ccy = (currency || 'KES').toString().toUpperCase();
    const n = Number(amount);
    if (!isFinite(n)) return `${ccy} 0`;
    // Some currencies have 0 decimals (TZS, UGX, RWF, BIF, XOF, XAF, KMF, GNF, DJF).
    // The catalogue knows the right value — but for hot display we just use locale
    // formatting and let the caller pre-round if precision matters.
    const zeroDecimal = ['TZS','UGX','RWF','BIF','XOF','XAF','KMF','GNF','DJF'].includes(ccy);
    const opts = zeroDecimal ? { maximumFractionDigits: 0 } : { maximumFractionDigits: 2 };
    return `${ccy} ${n.toLocaleString('en-KE', opts)}`;
};

export const getRight = (accessRole) => {
    // Get the string from sessionStorage and parse it into an array
    const selectedRolesString = sessionStorage.getItem("selectedRoles");

    if (!selectedRolesString) {
        //  console.error("selectedRoles is not available in sessionStorage");
        return false;  // or handle the absence of selectedRoles in sessionStorage
    }

    try {
        const selectedRoles = JSON.parse(selectedRolesString);

        if (!Array.isArray(selectedRoles)) {
            //  console.error("selectedRoles is not an array");
            return false;  // or handle the case where selectedRoles is not an array
        }

        let accessRight = false;

        for (const role of selectedRoles) {
            //  console.log(`${accessRole} role: ${role.role}`);
            if (role.role === accessRole) {
                accessRight = true;
                break;  // no need to continue checking once a match is found
            }
        }

        return accessRight;
    } catch (error) {
        //  console.error("Error parsing selectedRoles:", error);
        return false;  // or handle the error appropriately
    }
};

